export const CONNECTION_MODALS = {
  createConnection: 'createConnection',
  editConnection: 'editConnection',
};
